import styled from 'styled-components';
import { calcResize } from 'components/Layout/styles';

export const SSection = styled.div`
  background-color: #edf0f6;
  padding: 75px 0;
  overflow: hidden !important;
  position: relative;

  @media only screen and (max-width: 992px) {
    padding: 50px 0 25px;

    .image {
      display: none;
    }
  }

  .background-circles {
    margin-top: -800px;
    left: -200px;
    position: absolute;
  }
`;

export const SContainer = styled.div.attrs({
  className: 'container ',
})`
  overflow: hidden !important;
`;

export const SRow = styled.div.attrs({
  className: 'd-flex mb-5 justify-content-center justify-content-lg-start row',
})``;

export const SCol = styled.div.attrs({
  className: 'col-12 col-md-6 text-center text-lg-start col',
})``;

export const SSVGHolder = styled.div`
  @media only screen and (max-width: 992px) {
    display: none;
  }
`;
